var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "44px",
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9CCA84EB-D0D6-42C1-B8A7-3F7621E34D4F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legal-statements-svg-icons",
    transform: "translate(-212.000000, -110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-83",
    transform: "translate(213.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,18 C3.80367932,19.4536 7.4372224,20.1804001 10.9006292,20.1804001 C16.0957395,20.1804001 16.0898603,18 21.2603011,18 C24.7072616,18 28.1538282,18.7268 31.6000009,20.1804001 L31.6000009,36.1700005 C28.1596977,34.7164005 24.7131311,33.9896004 21.2603011,33.9896004 C16.0810561,33.9896004 16.3356695,36.1700005 10.9006292,36.1700005 C7.27726904,36.1700005 3.64372596,35.4432005 1.77635684e-15,33.9896004 L1.77635684e-15,18 Z",
    id: "Rectangle-Copy-56",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    transform: "translate(15.800000, 27.085000) scale(-1, 1) translate(-15.800000, -27.085000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,15 C3.80367932,16.4536 7.4372224,17.1804001 10.9006292,17.1804001 C16.0957395,17.1804001 16.0898603,15 21.2603011,15 C24.7072616,15 28.1538282,15.7268 31.6000009,17.1804001 L31.6000009,33.1700005 C28.1596977,31.7164005 24.7131311,30.9896004 21.2603011,30.9896004 C16.0810561,30.9896004 16.3356695,33.1700005 10.9006292,33.1700005 C7.27726904,33.1700005 3.64372596,32.4432005 1.77635684e-15,30.9896004 L1.77635684e-15,15 Z",
    id: "Rectangle-Copy-56",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    transform: "translate(15.800000, 24.085000) scale(-1, 1) translate(-15.800000, -24.085000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,12 C3.80367932,13.4536 7.4372224,14.1804001 10.9006292,14.1804001 C16.0957395,14.1804001 16.0898603,12 21.2603011,12 C24.7072616,12 28.1538282,12.7268 31.6000009,14.1804001 L31.6000009,30.1700005 C28.1596977,28.7164005 24.7131311,27.9896004 21.2603011,27.9896004 C16.0810561,27.9896004 16.3356695,30.1700005 10.9006292,30.1700005 C7.27726904,30.1700005 3.64372596,29.4432005 1.77635684e-15,27.9896004 L1.77635684e-15,12 Z",
    id: "Rectangle-Copy-56",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    transform: "translate(15.800000, 21.085000) scale(-1, 1) translate(-15.800000, -21.085000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,9 C3.80367932,10.4536 7.4372224,11.1804001 10.9006292,11.1804001 C16.0957395,11.1804001 16.0898603,9 21.2603011,9 C24.7072616,9 28.1538282,9.72680002 31.6000009,11.1804001 L31.6000009,27.1700005 C28.1596977,25.7164005 24.7131311,24.9896004 21.2603011,24.9896004 C16.0810561,24.9896004 16.3356695,27.1700005 10.9006292,27.1700005 C7.27726904,27.1700005 3.64372596,26.4432005 1.77635684e-15,24.9896004 L1.77635684e-15,9 Z",
    id: "Rectangle-Copy-56",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    transform: "translate(15.800000, 18.085000) scale(-1, 1) translate(-15.800000, -18.085000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,6 C3.80367932,7.45360004 7.4372224,8.18040006 10.9006292,8.18040006 C16.0957395,8.18040006 16.0898603,6 21.2603011,6 C24.7072616,6 28.1538282,6.72680002 31.6000009,8.18040006 L31.6000009,24.1700005 C28.1596977,22.7164005 24.7131311,21.9896004 21.2603011,21.9896004 C16.0810561,21.9896004 16.3356695,24.1700005 10.9006292,24.1700005 C7.27726904,24.1700005 3.64372596,23.4432005 1.77635684e-15,21.9896004 L1.77635684e-15,6 Z",
    id: "Rectangle-Copy-56",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    transform: "translate(15.800000, 15.085000) scale(-1, 1) translate(-15.800000, -15.085000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,3 C3.80367932,4.45360004 7.4372224,5.18040006 10.9006292,5.18040006 C16.0957395,5.18040006 16.0898603,3 21.2603011,3 C24.7072616,3 28.1538282,3.72680002 31.6000009,5.18040006 L31.6000009,21.1700005 C28.1596977,19.7164005 24.7131311,18.9896004 21.2603011,18.9896004 C16.0810561,18.9896004 16.3356695,21.1700005 10.9006292,21.1700005 C7.27726904,21.1700005 3.64372596,20.4432005 1.77635684e-15,18.9896004 L1.77635684e-15,3 Z",
    id: "Rectangle-Copy-56",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    transform: "translate(15.800000, 12.085000) scale(-1, 1) translate(-15.800000, -12.085000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77635684e-15,0 C3.80367932,1.45360004 7.4372224,2.18040006 10.9006292,2.18040006 C16.0957395,2.18040006 16.0898603,0 21.2603011,0 C24.7072616,0 28.1538282,0.72680002 31.6000009,2.18040006 L31.6000009,18.1700005 C28.1596977,16.7164005 24.7131311,15.9896004 21.2603011,15.9896004 C16.0810561,15.9896004 16.3356695,18.1700005 10.9006292,18.1700005 C7.27726904,18.1700005 3.64372596,17.4432005 1.77635684e-15,15.9896004 L1.77635684e-15,0 Z",
    id: "Rectangle-Copy-56",
    stroke: "#788999",
    fill: "#E7EAF3",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    transform: "translate(15.800000, 9.085000) scale(-1, 1) translate(-15.800000, -9.085000) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy",
    stroke: "#788999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(28.345818, 4.180557) scale(-1, 1) translate(-28.345818, -4.180557) ",
    points: "29.5308183 3.78555658 27.1608182 2.99555656 27.1608182 5.36555662"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy-2",
    stroke: "#788999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "4.24275648 2.99555656 1.87275642 3.78555658 1.87275642 6.15555664"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy-3",
    stroke: "#788999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(28.057756, 13.575557) scale(-1, -1) translate(-28.057756, -13.575557) ",
    points: "29.2427565 11.9955566 26.8727564 12.7855566 26.8727564 15.1555566"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy-4",
    stroke: "#788999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(3.057756, 14.180557) scale(1, -1) translate(-3.057756, -14.180557) ",
    points: "4.24275648 13.7855566 1.87275642 12.9955566 1.87275642 15.3655566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8327624,10.1199353 C23.4882899,10.5579407 24.1466233,10.8100003 24.8077625,10.8761143 C25.4689016,10.9422282 26.127235,10.8218352 26.7827625,10.5149353",
    id: "Path-15",
    stroke: "#788999",
    strokeLinecap: "round",
    transform: "translate(24.807762, 10.506813) scale(-1, 1) translate(-24.807762, -10.506813) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02054816,7.34439537 C4.67607567,7.78240074 5.33440903,8.03446038 5.99554821,8.1005743 C6.6566874,8.16668822 7.31502075,8.04629525 7.97054827,7.73939538",
    id: "Path-15",
    stroke: "#788999",
    strokeLinecap: "round",
    transform: "translate(5.995548, 7.731273) scale(1, -1) translate(-5.995548, -7.731273) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-34",
    stroke: "#788999",
    fill: "#F8F9FC",
    cx: 15.3161825,
    cy: 9.0511684,
    r: 5.92500016
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6147295,13.1916375 L15.6147295,12.078347 C16.298779,12.0031015 16.8220768,11.8047272 17.1846231,11.4832239 C17.5471693,11.1617206 17.7284424,10.7530011 17.7284424,10.2570652 C17.7284424,9.85689624 17.6036034,9.51829175 17.3539253,9.2412517 C17.1042473,8.96421166 16.6544847,8.70085261 16.0046377,8.45117454 L16.0046377,8.45117454 L15.6147295,8.30239378 L15.6147295,6.43493868 C16.1448679,6.47598164 16.6784265,6.6025308 17.2154053,6.81458614 L17.2154053,6.81458614 L17.5899224,5.87572822 C16.9674374,5.61920966 16.3090397,5.47897951 15.6147295,5.45503778 L15.6147295,5.45503778 L15.6147295,4.60852654 L14.9323901,4.60852654 L14.9323901,5.4704289 C14.3030646,5.5354136 13.8045635,5.72010696 13.4368869,6.02450898 C13.0692103,6.328911 12.885372,6.71710909 12.885372,7.18910324 C12.885372,7.63031516 13.0144864,8.00055694 13.2727151,8.2998286 C13.5309437,8.59910025 13.9405184,8.85647387 14.501439,9.07194946 L14.501439,9.07194946 L14.9323901,9.23099096 L14.9323901,11.1497498 C14.6211476,11.1463295 14.2688621,11.0958809 13.8755337,10.9984038 C13.4822052,10.9009268 13.1384703,10.7803631 12.8443291,10.6367127 L12.8443291,10.6367127 L12.8443291,11.719221 C13.3881484,11.9654788 14.0841688,12.0954482 14.9323901,12.1091292 L14.9323901,12.1091292 L14.9323901,13.1916375 L15.6147295,13.1916375 Z M14.9323901,8.05100559 C14.6143071,7.92445644 14.3945562,7.79619716 14.2731374,7.66622776 C14.1517187,7.53625835 14.0910093,7.3737966 14.0910093,7.17884249 C14.0910093,6.99072889 14.1628345,6.8333975 14.3064848,6.70684835 C14.4501352,6.58029919 14.6587703,6.49650313 14.9323901,6.45546016 L14.9323901,6.45546016 L14.9323901,8.05100559 Z M15.6147295,11.1087068 L15.6147295,9.47211841 C15.939653,9.59182707 16.1713748,9.71581104 16.3098948,9.84407032 C16.4484148,9.9723296 16.5176748,10.1356464 16.5176748,10.3340208 C16.5176748,10.7581314 16.216693,11.0163601 15.6147295,11.1087068 L15.6147295,11.1087068 Z",
    id: "$",
    fill: "#788999",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.9860959,
    y1: 4.51096177,
    x2: 15.6139041,
    y2: 13.4890382,
    id: "Line-35",
    stroke: "#788999",
    transform: "translate(15.300000, 9.000000) rotate(4.000000) translate(-15.300000, -9.000000) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-131",
    transform: "translate(12.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#788999",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 26,
    height: 19,
    rx: 1.09289891
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#788999",
    x: 1.8189894e-12,
    y: 3.16666667,
    width: 26,
    height: 4.22222222
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0D6E7",
    x: 2,
    y: 14.7777778,
    width: 3,
    height: 2.11111111,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0D6E7",
    x: 6,
    y: 14.7777778,
    width: 5,
    height: 2.11111111,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0D6E7",
    x: 2,
    y: 11.6111111,
    width: 11,
    height: 2.11111111,
    rx: 1.05555556
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D0D6E8",
    cx: 21.5,
    cy: 14.25,
    rx: 2.5,
    ry: 2.63888889
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#788999",
    cx: 17.5,
    cy: 14.25,
    rx: 2.5,
    ry: 2.63888889
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/moneyIcon.ed12b1386f88e7cd18cd25ed485120b9.svg";
export { ForwardRef as ReactComponent };